import WebSpinner from "../spinner/Spinner";
import { SPINNER_SIZES } from "../spinner/spinnerConstants";
import styles from "./main-spinner.module.scss";

export const MainSpinner = () => (
  <div
    className={`${styles.spinnerContainer} flex main-content align-center center`}
  >
    <WebSpinner size={SPINNER_SIZES.LARGE} />
  </div>
);

export default MainSpinner;
